package org.zest.insan_360_website.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import org.jetbrains.compose.web.css.*

val loadingDotAnimation = Keyframes {
    0.percent {
        Modifier.transform { translateY(0.px) }
    }
    16.6.percent {
        Modifier.transform { translateY((-15).px) }
    }
    33.3.percent {
        Modifier.transform { translateY(0.px) }
    }
    40.percent {
        Modifier.transform { translateY((-2).px) }
    }
    50.percent {
        Modifier.transform { translateY(0.px) }
    }
    100.percent {
        Modifier.transform { translateY(0.px) }
    }
}

@Composable
fun loadingDotAnimation(delayMs: Int): Modifier {
    return Modifier.animation(
        loadingDotAnimation.toAnimation(
            duration = 1.5.s,
            timingFunction = AnimationTimingFunction.EaseInOut,
            delay = delayMs.ms,
            iterationCount = AnimationIterationCount.Infinite
        )
    )
}

@Composable
fun DotLoading(
    textColor: CSSColorValue = Colors.Black,
    dotModifier: Modifier = Modifier
) {
    val dotStyle = dotModifier
        .size(0.25.cssRem)
        .backgroundColor(textColor)
        .borderRadius(99.px)

    Row(
        Modifier
            .gap(0.25.cssRem)
    ) {
       Box(loadingDotAnimation(0).then(dotStyle))
       Box(loadingDotAnimation(150).then(dotStyle))
       Box(loadingDotAnimation(300).then(dotStyle))
    }
}